import React from 'react';
import styled from 'styled-components';

import { Source } from 'shared/types/source';

import { SourceNavContentProps } from './types';

const StyledContainer = styled.div``;

const StyledSourceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0.75rem;

  &:not(:last-child) {
    margin-bottom: 0.416666667rem;
  }
`;

const StyledSourceName = styled.span`
  margin-right: 1rem;
`;

const StyledSourceWeight = styled.span``;

const renderSourceValues = (sources: Source[]) => sources.map(({ name, weight, id }) => (
  <StyledSourceWrapper key={id}>
    <StyledSourceName>{name}</StyledSourceName>
    <StyledSourceWeight>{weight}</StyledSourceWeight>
  </StyledSourceWrapper>
));

const SourceNavContent = ({
  values: sources,
}: SourceNavContentProps) => (
  <StyledContainer>
    {renderSourceValues(sources)}
  </StyledContainer>
);

export default SourceNavContent;
